import React from "react"
import PropTypes from "prop-types"
import ContainerBox from "./containerBox"
import Calendar from "./calendar"
import brownTriangle from "../../assets/imgs/brownTriangle.png"
import dictionary from "../../utils/dictionary"

const CrmRecordsLoadingShell = ({
  selectedLanguage,
  firstDay,
  handleSetDate,
  handleDateSelect,
  titleKey = "serviceList",
}) => (
  <div className="container-fluid relative mx-auto h-[calc(100vh-252px)] flex justify-center items-start bg-cream">
    <ContainerBox>
      <h2 className="text-brown text-2xl max-md:text-lg">
        {dictionary[selectedLanguage][titleKey]}
      </h2>
      <div className="flex items-center">
        <img
          className="-rotate-90 w-[12px] h-[15px]"
          src={brownTriangle}
          alt=""
          onClick={() =>
            handleSetDate(new Date(firstDay.getTime() - 1000 * 60 * 60 * 24))
          }
        />
        <Calendar
          date={new Date(firstDay.getTime())}
          handleSelectDate={handleDateSelect}
        />
        <img
          className="rotate-90 w-[12px] h-[15px]"
          src={brownTriangle}
          alt=""
          onClick={() =>
            handleSetDate(new Date(firstDay.getTime() + 1000 * 60 * 60 * 24))
          }
        />
      </div>
      <div className="text-gray text-sm py-8 text-center" aria-busy="true">
        …
      </div>
    </ContainerBox>
  </div>
)

CrmRecordsLoadingShell.propTypes = {
  selectedLanguage: PropTypes.string.isRequired,
  firstDay: PropTypes.instanceOf(Date).isRequired,
  handleSetDate: PropTypes.func.isRequired,
  handleDateSelect: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
}

export default CrmRecordsLoadingShell
